module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasPlans) ? _c('div', {
    staticClass: "program"
  }, [_c('i', {
    staticClass: "program-bookmark fa fa-bookmark"
  }), _vm._v(" "), _c('div', {
    class: {
      "program-line": _vm.concentrations.length > 0
    }
  }), _vm._v(" "), _vm._l((_vm.programsToShow), function(program) {
    return _c('unit', {
      key: program.university_layout_id,
      attrs: {
        "unit": program
      }
    })
  }), _vm._v(" "), _vm._l((_vm.concentrations), function(concentration) {
    return _c('unit', {
      key: concentration.id,
      staticClass: "concentration",
      attrs: {
        "unit": concentration
      }
    })
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27fd3e70","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/program.vue
// module id = 1118
// module chunks = 1